// Authentication service for Nova Dent application
class AuthService {
  constructor() {
    this.AUTH_KEY = 'isAuthenticated';
    this.LOGIN_TIME_KEY = 'loginTime';
    this.SESSION_DURATION = 8 * 60 * 60 * 1000; // 8 hours in milliseconds
  }

  // Check if user is currently authenticated
  isAuthenticated() {
    const isAuth = localStorage.getItem(this.AUTH_KEY);
    const loginTime = localStorage.getItem(this.LOGIN_TIME_KEY);
    
    if (!isAuth || !loginTime) {
      return false;
    }

    // Check if session has expired
    const loginTimestamp = new Date(loginTime).getTime();
    const currentTime = new Date().getTime();
    const timeDifference = currentTime - loginTimestamp;

    if (timeDifference > this.SESSION_DURATION) {
      // Session expired, clear storage
      this.logout();
      return false;
    }

    return isAuth === 'true';
  }

  // Login user
  login() {
    localStorage.setItem(this.AUTH_KEY, 'true');
    localStorage.setItem(this.LOGIN_TIME_KEY, new Date().toISOString());
  }

  // Logout user
  logout() {
    localStorage.removeItem(this.AUTH_KEY);
    localStorage.removeItem(this.LOGIN_TIME_KEY);
  }

  // Get remaining session time in minutes
  getRemainingSessionTime() {
    const loginTime = localStorage.getItem(this.LOGIN_TIME_KEY);
    if (!loginTime) return 0;

    const loginTimestamp = new Date(loginTime).getTime();
    const currentTime = new Date().getTime();
    const timeDifference = currentTime - loginTimestamp;
    const remainingTime = this.SESSION_DURATION - timeDifference;

    return Math.max(0, Math.floor(remainingTime / (1000 * 60))); // Convert to minutes
  }

  // Extend session (refresh login time)
  extendSession() {
    if (this.isAuthenticated()) {
      localStorage.setItem(this.LOGIN_TIME_KEY, new Date().toISOString());
    }
  }
}

// Create and export a singleton instance
const authService = new AuthService();
export default authService;